import React from "react";
import gitimg from '../img/git-hub.png';

function Footer() {
    const gitButtonClick = () => {
        window.open('https://github.com/summerryu', '_blank', 'noopener,noreferrer');
    };
    return (
        <div className="footer">
            <div className="footer_list">
                <div className="footer_ikon_list">
                    <div onClick={gitButtonClick}>
                        <img src={gitimg}></img>
                    </div>
                </div>
                <p>© 2024. Yu Yeo Reum. All rights reserved.</p>
            </div>
        </div>
    )
}

export default Footer;


